<template>
  <div v-if="visible" class="scan-velo" @dragover.prevent @drop.prevent="rilascia">
    <div class="scan-finestra" role="dialog" aria-modal="true" :aria-label="t.titolo">
      <div class="scan-testata" :style="tema">
        <span class="scan-testata-titolo">{{ t.titolo }}</span>
        <button type="button" class="scan-x" :style="{ color: primoPiano }" :aria-label="t.chiudi" @click="chiudi"><fa :icon="['fas', 'times']" /></button>
      </div>

      <div class="scan-corpo">
        <!-- ================= INIZIO ================= -->
        <div v-if="!foto.length && !dati" class="scan-inizio">
          <button type="button" class="scan-grande" :style="tema" @click="apriFotocamera">
            <span class="scan-grande-icona"><fa :icon="['fas', 'id-card']" /></span>
            <span class="scan-grande-titolo">{{ t.bottone }}</span>
            <span class="scan-grande-sotto">{{ t.documenti }}</span>
          </button>
          <button type="button" class="scan-carica" :style="{ borderColor: colore, color: colore }" @click="$refs.file.click()">
            <fa :icon="['fas', 'file-upload']" class="mr-2" />{{ t.carica }}
          </button>
          <div v-if="errore" class="scan-avviso"><fa :icon="['fas', 'exclamation-triangle']" class="mr-1" />{{ errore }}</div>
          <div class="scan-lati">
            <b>{{ t.latoTitolo }}</b><br />
            {{ t.latoCie }}<br />
            {{ t.latoPassaporto }}<br />
            {{ t.latoPatente }}
            <!-- il documento lontano non si legge: mancano i pixel -->
            <div class="scan-avvicinati"><fa :icon="['fas', 'expand']" class="mr-2" />{{ t.avvicinati }}</div>
          </div>
          <div class="scan-privacy">
            <fa :icon="['fas', 'lock']" />
            <span>{{ usaAppFotocamera ? t.privacyTelefono : t.privacy }}</span>
          </div>
        </div>

        <!-- ================= FOTO E DATI ================= -->
        <div v-else class="scan-documento">
          <div class="scan-foto-griglia">
            <div v-for="(f, i) in foto" :key="f.id" class="scan-foto">
              <img :src="f.anteprima" alt="" />
              <div v-if="f.sfocata && t.fotoSfocata" class="scan-foto-sfocata">{{ t.fotoSfocata }}</div>
              <div class="scan-foto-stato" :class="'stato-' + f.stato" :style="f.stato === 'ok' ? tema : {}">{{ statoFoto(f) }}</div>
              <button type="button" class="scan-foto-togli" :disabled="f.stato === 'lettura'" @click="togli(i)"><fa :icon="['fas', 'times']" /></button>
            </div>
            <button type="button" class="scan-foto-aggiungi" :style="{ color: colore }" @click="apriFotocamera">
              <fa :icon="['fas', 'camera']" class="scan-foto-aggiungi-icona" />
              <span>{{ foto.length ? t.altroLato : t.scatta }}</span>
              <small>{{ foto.length ? t.facoltativo : "" }}</small>
            </button>
          </div>
          <button type="button" class="scan-link" :style="{ color: colore }" @click="$refs.file.click()"><fa :icon="['fas', 'file-upload']" class="mr-1" />{{ t.carica }}</button>
          <div v-if="errore" class="scan-avviso"><fa :icon="['fas', 'exclamation-triangle']" class="mr-1" />{{ errore }}</div>

          <div ref="dati" class="scan-dati">
            <div v-if="!dati && !inAttesa" class="scan-avviso"><fa :icon="['fas', 'exclamation-triangle']" class="mr-1" />{{ t.nonLetto }}</div>

            <template v-if="dati">
              <div class="scan-nota">{{ t.controlla }}</div>
              <!-- _______________ persona _______________ -->
              <div class="scan-sezione">
                <div class="persona_label">{{ t.persona }}</div>
                <div class="row">
                  <div class="col-12 col-md-6 scan-campo">
                    <div class="scan-etichetta">
                      <span>{{ labels.Cognome }}</span><span v-if="badge('cognome')" :class="'scan-badge badge-' + badge('cognome')">{{ testoBadge("cognome") }}</span>
                    </div>
                    <div class="cyb-input"><input v-model="dati.cognome" :placeholder="labels.Cognome" autocomplete="off" @input="segna('cognome')" /></div>
                  </div>
                  <div class="col-12 col-md-6 scan-campo">
                    <div class="scan-etichetta">
                      <span>{{ labels.Nome }}</span><span v-if="badge('nome')" :class="'scan-badge badge-' + badge('nome')">{{ testoBadge("nome") }}</span>
                    </div>
                    <div class="cyb-input"><input v-model="dati.nome" :placeholder="labels.Nome" autocomplete="off" @input="segna('nome')" /></div>
                  </div>
                  <div class="col-12 col-md-6 scan-campo">
                    <div class="scan-etichetta">
                      <span>{{ labels.datanascita }}</span><span v-if="badge('data_nascita')" :class="'scan-badge badge-' + badge('data_nascita')">{{ testoBadge("data_nascita") }}</span>
                    </div>
                    <div class="cyb-input">
                      <input v-model="dati.data_nascita" style="text-align: center" inputmode="numeric" placeholder="gg/mm/aaaa" maxlength="10" @input="segna('data_nascita')" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6 scan-campo">
                    <div class="cyb-radio riepilogo-radio scan-sesso">
                      <label>
                        <input v-model="dati.sesso" type="radio" value="m" @change="segna('sesso')" />
                        <span>{{ labels.Uomo }}</span>
                      </label>
                      <label>
                        <input v-model="dati.sesso" type="radio" value="f" @change="segna('sesso')" />
                        <span>{{ labels.Donna }}</span>
                      </label>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 scan-campo">
                    <div class="scan-etichetta">
                      <span>{{ labels.Cittadinanza }}</span><span v-if="badge('cittadinanza')" :class="'scan-badge badge-' + badge('cittadinanza')">{{ testoBadge("cittadinanza") }}</span>
                    </div>
                    <div class="cyb-input cyb-select">
                      <select v-model="dati.cittadinanza" @change="segna('cittadinanza')">
                        <option v-for="o in opzioniPiene(nazioni)" :key="o.key" :value="o.key">{{ o.label }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 scan-campo">
                    <div class="scan-etichetta">
                      <span>{{ labels.nazionenascita }}</span><span v-if="badge('nazione_nascita')" :class="'scan-badge badge-' + badge('nazione_nascita')">{{ testoBadge("nazione_nascita") }}</span>
                    </div>
                    <div class="cyb-input cyb-select">
                      <select v-model="dati.nazione_nascita" @change="segna('nazione_nascita')">
                        <option v-for="o in opzioniPiene(nazioni)" :key="o.key" :value="o.key">{{ o.label }}</option>
                      </select>
                    </div>
                  </div>
                  <template v-if="italiano(dati.nazione_nascita)">
                    <div class="col-12 col-md-6 scan-campo">
                      <div class="scan-etichetta">
                        <span>{{ labels.provnascita }}</span><span v-if="badge('prov_nascita')" :class="'scan-badge badge-' + badge('prov_nascita')">{{ testoBadge("prov_nascita") }}</span>
                      </div>
                      <div class="cyb-input cyb-select">
                        <select v-model="dati.prov_nascita" @change="cambiaProvincia">
                          <option v-for="o in opzioniPiene(province)" :key="o.key" :value="o.key">{{ o.label }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 scan-campo">
                      <div class="scan-etichetta">
                        <span>{{ labels.comunenascita }}</span><span v-if="badge('comune_nascita')" :class="'scan-badge badge-' + badge('comune_nascita')">{{ testoBadge("comune_nascita") }}</span>
                      </div>
                      <div class="cyb-input cyb-select">
                        <select v-model="dati.comune_nascita" @change="segna('comune_nascita')">
                          <option v-for="o in opzioniPiene(comuniNascita)" :key="o.key" :value="o.key">{{ o.label }}</option>
                        </select>
                      </div>
                    </div>
                  </template>
                  <div class="col-12 col-md-6 scan-campo">
                    <div class="scan-etichetta">
                      <span>{{ labels.nazioneresid }}</span><span v-if="badge('nazione_residenza')" :class="'scan-badge badge-' + badge('nazione_residenza')">{{ testoBadge("nazione_residenza") }}</span>
                    </div>
                    <div class="cyb-input cyb-select">
                      <select v-model="dati.nazione_residenza" @change="segna('nazione_residenza')">
                        <option v-for="o in opzioniPiene(nazioni)" :key="o.key" :value="o.key">{{ o.label }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <!-- _______________ documento _______________ -->
              <div class="scan-sezione">
                <div class="persona_label">{{ t.documento }}</div>
                <div class="row">
                  <div class="col-12 col-md-6 scan-campo">
                    <div class="scan-etichetta">
                      <span>{{ labels.TipoDoc }}</span><span v-if="badge('tipodoc')" :class="'scan-badge badge-' + badge('tipodoc')">{{ testoBadge("tipodoc") }}</span>
                    </div>
                    <div class="cyb-input cyb-select">
                      <select v-model="dati.tipodoc" @change="segna('tipodoc')">
                        <option v-for="o in opzioniPiene(tipidoc)" :key="o.key" :value="o.key">{{ o.label }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 scan-campo">
                    <div class="scan-etichetta">
                      <span>{{ labels.NumDoc }}</span><span v-if="badge('nrodoc')" :class="'scan-badge badge-' + badge('nrodoc')">{{ testoBadge("nrodoc") }}</span>
                    </div>
                    <div class="cyb-input"><input v-model="dati.nrodoc" :placeholder="labels.NumDoc" autocomplete="off" @input="segna('nrodoc')" /></div>
                  </div>
                  <div class="col-12 col-md-6 scan-campo">
                    <div class="scan-etichetta">
                      <span>{{ labels.nazioneril }}</span><span v-if="badge('nazione_rilascio')" :class="'scan-badge badge-' + badge('nazione_rilascio')">{{ testoBadge("nazione_rilascio") }}</span>
                    </div>
                    <div class="cyb-input cyb-select">
                      <select v-model="dati.nazione_rilascio" @change="segna('nazione_rilascio')">
                        <option v-for="o in opzioniPiene(nazioni)" :key="o.key" :value="o.key">{{ o.label }}</option>
                      </select>
                    </div>
                  </div>
                  <div v-if="italiano(dati.nazione_rilascio)" class="col-12 col-md-6 scan-campo">
                    <div class="scan-etichetta">
                      <span>{{ labels.comuneril }}</span><span v-if="badge('comune_rilascio')" :class="'scan-badge badge-' + badge('comune_rilascio')">{{ testoBadge("comune_rilascio") }}</span>
                    </div>
                    <div class="cyb-input cyb-select">
                      <select v-model="dati.comune_rilascio" @change="segna('comune_rilascio')">
                        <option v-for="o in opzioniPiene(comuni)" :key="o.key" :value="o.key">{{ o.label }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <!--
                Attribuzione richiesta dalla licenza CC BY 4.0 dei dati usati per
                decodificare comuni e stati: vedi backend dotweb
                modules/dothotel/docscan/LEGGIMI.md. Uguale in tutte le lingue.
              -->
              <div class="scan-crediti">
                Codici di comuni e stati: elaborazione su dati ANPR – Ministero dell'Interno e ISTAT, licenza
                <a href="https://creativecommons.org/licenses/by/4.0/deed.it" target="_blank" rel="noopener">CC BY 4.0</a>.
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- Comandi fissi in basso -->
      <div class="scan-barra">
        <button type="button" class="scan-barra-annulla" @click="chiudi">{{ t.annulla }}</button>
        <button type="button" class="scan-barra-usa cybtn" :style="tema" :disabled="!dati || inAttesa" @click="usa">
          <fa :icon="['fas', 'check']" class="mr-2" />{{ t.usaDati }}
        </button>
      </div>
    </div>

    <input ref="file" type="file" accept="image/*" multiple class="d-none" @change="aggiungi" />
    <!-- App Fotocamera del telefono (parametro app.docscan.fotocameraTelefono) -->
    <input ref="scattoTelefono" type="file" accept="image/*" capture="environment" class="d-none" @change="aggiungi" />

    <!-- Fotocamera a schermo intero: lo scatto resta in memoria, non diventa un file -->
    <div v-if="fotocamera.attiva" class="scan-fotocamera">
      <video ref="video" autoplay playsinline muted />
      <div ref="cornice" class="scan-cornice" />
      <div class="scan-fotocamera-testo">
        <template v-if="foto.length">{{ t.oraAltroLato }}</template>
        <template v-else>{{ t.latoCie }} {{ t.latoPassaporto }} {{ t.latoPatente }}</template>
        <div class="scan-fotocamera-sotto">{{ t.inquadra }}</div>
      </div>
      <div class="scan-fotocamera-comandi">
        <button type="button" class="scan-fotocamera-chiudi" @click="chiudiFotocamera"><fa :icon="['fas', 'times']" class="mr-2" />{{ t.chiudi }}</button>
        <button type="button" class="scan-scatta" :aria-label="t.scatta" :disabled="!fotocamera.pronta || fotocamera.scatto" @click="scatta"><span /></button>
        <div class="scan-fotocamera-lato" />
      </div>
    </div>

    <!-- Attesa a tutto schermo finche' non sono lette tutte le foto -->
    <div v-if="inAttesa" class="scan-attesa">
      <div class="scan-attesa-percentuale" :style="{ color: colore }">{{ Math.round(percentuale) }}%</div>
      <div class="scan-attesa-barra"><div :style="{ width: percentuale + '%', backgroundColor: colore }" /></div>
      <div class="scan-attesa-titolo">{{ t.lettura }}</div>
      <div class="scan-attesa-nota">{{ t.attesa }}</div>
      <div v-if="foto.length > 1" class="scan-attesa-passi">
        <div v-for="(f, i) in foto" :key="f.id" :class="'passo-' + f.stato">{{ i + 1 }}. {{ statoFoto(f) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Scansione del documento nel web check-in.
 *
 * E' la finestra della reception (scheda persona del gestionale) con i campi
 * del web check-in e il colore dell'hotel. Le foto si leggono nel browser
 * dell'ospite (services/docscan, stessa copia del gestionale): la foto non
 * lascia il dispositivo, al server arrivano solo i dati letti, che
 * BE_prenotazione/docscan traduce nei codici delle tabelle. "Usa questi
 * dati" li riporta nei campi dell'ospite (evento "applica").
 */
import apiService from "../services/api.js";
import formService from "../services/form";
import docscan from "../services/docscan";
import { apriFlusso, scatta as scattaFoto } from "../services/docscan/fotocamera";
import { corrispondeA } from "../services/docscan/codicefiscale";
import { unisciViz } from "../services/docscan/viz";

const ITALIA = "100000100";

/** Campo del web check-in -> campo della decodifica (per l'affidabilita'). */
const FONTE = {
  cognome: "cognome",
  nome: "nome",
  sesso: "sesso",
  data_nascita: "datanascita",
  cittadinanza: "nazionalita",
  nazione_nascita: "nazione_na",
  prov_nascita: "citta_na",
  comune_nascita: "citta_na",
  nazione_residenza: "nazione",
  tipodoc: "tipodoc1",
  nrodoc: "numdoc",
  nazione_rilascio: "stato",
  comune_rilascio: "comune"
};

let progressivo = 0;

const lettureVuote = () => ({ mrz: null, codiceFiscale: null, patenteUsa: null, patenteUe: null, viz: null });
const codice = (x) => (x && typeof x === "object" ? x.id : x) || "";

export default {
  name: "CybScansione",
  props: {
    visible: { type: Boolean, default: false },
    // token della prenotazione (link del riepilogo)
    token: { type: String, default: "" },
    labels: { type: Object, default: () => ({}) },
    nazioni: { type: Array, default: () => [] },
    province: { type: Array, default: () => [] },
    comuni: { type: Array, default: () => [] },
    tipidoc: { type: Array, default: () => [] },
    // sul telefono "Scatta" apre l'app Fotocamera invece della fotocamera nella pagina
    fotocameraTelefono: { type: Boolean, default: true }
  },
  data() {
    return {
      fotocamera: { attiva: false, pronta: false, scatto: false },
      foto: [],
      letture: lettureVuote(),
      // valori con i nomi dei campi del web check-in
      dati: null,
      // affidabilita' per campo: verificato, coerente, letto, proposto
      affidabilita: {},
      // campi corretti dall'ospite: un'altra foto non li sovrascrive
      modificati: {},
      comuniNascita: [],
      // nome del comune di nascita letto: puo' essere un comune soppresso,
      // che l'elenco della provincia (solo comuni attivi) non ha
      nomeComuneNascita: "",
      richieste: 0,
      // percentuale stimata della lettura, mostrata durante l'attesa
      percentuale: 0,
      errore: ""
    };
  },
  computed: {
    t() {
      return this.labels.scan || {};
    },
    colore() {
      return this.$theme.basecolor;
    },
    primoPiano() {
      return formService.perceivedBrightness(this.colore) > 138 ? "#000000" : "#ffffff";
    },
    tema() {
      return { backgroundColor: this.colore, color: this.primoPiano };
    },
    /** App Fotocamera: se il parametro lo dice e il dispositivo e' un telefono o un tablet. */
    usaAppFotocamera() {
      const touch = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
      return this.fotocameraTelefono && !!touch;
    },
    inLettura() {
      return this.foto.some((f) => f.stato === "lettura" || f.stato === "attesa");
    },
    inAttesa() {
      return this.inLettura || this.richieste > 0;
    },
    /**
     * Tratto di percentuale in cui si e' (0-100 su tutte le foto): le foto
     * lette contano 100, quella in lettura il tratto della sua fase. Le foto
     * arrivano al 95%, il resto e' la risposta del server.
     */
    trattoLettura() {
      if (!this.inLettura) {
        return { da: 95, a: 99 };
      }
      const n = this.foto.length || 1;
      let da = 0;
      let a = 0;
      this.foto.forEach((f) => {
        const fatta = f.stato === "ok" || f.stato === "vuoto" || f.stato === "errore";
        da += fatta ? 100 : f.stato === "lettura" ? f.da : 0;
        a += fatta ? 100 : f.stato === "lettura" ? f.a : 0;
      });
      return { da: (da / n) * 0.95, a: (a / n) * 0.95 };
    }
  },
  watch: {
    visible(v) {
      if (v) {
        docscan.configura(this.$config.server_url.replace(/\/rest\/?$/, "") + "/statics/docscan");
        // librerie e modelli si scaricano mentre l'ospite inquadra
        docscan.prepara().catch(() => {});
      }
    },
    // finita la lettura di tutte le foto si porta l'ospite sui dati da controllare;
    // durante l'attesa la percentuale sale da sola dentro il tratto della fase
    // in corso (senza raggiungerne la fine) e non torna mai indietro
    inAttesa(ora, prima) {
      clearInterval(this.timerPercentuale);
      this.percentuale = 0;
      if (ora) {
        this.timerPercentuale = setInterval(() => {
          const { da, a } = this.trattoLettura;
          const x = Math.max(this.percentuale, da);
          this.percentuale = Math.max(this.percentuale, Math.min(a, x + (a - x) * 0.06));
        }, 250);
      }
      if (prima && !ora && this.dati) {
        this.$nextTick(() => this.$refs.dati && this.$refs.dati.scrollIntoView({ behavior: "smooth", block: "start" }));
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timerPercentuale);
    this.svuota();
  },
  methods: {
    chiudi() {
      this.svuota();
      this.$emit("close");
    },
    usa() {
      // il nome del comune serve alla scheda se e' un comune soppresso
      this.$emit("applica", { ...this.dati }, { comune_nascita: this.nomeComuneNascita });
      this.chiudi();
    },
    svuota() {
      this.chiudiFotocamera();
      this.foto.forEach((f) => URL.revokeObjectURL(f.anteprima));
      this.foto = [];
      this.letture = lettureVuote();
      this.dati = null;
      this.affidabilita = {};
      this.modificati = {};
      this.comuniNascita = [];
      this.nomeComuneNascita = "";
      this.errore = "";
    },
    togli(i) {
      URL.revokeObjectURL(this.foto[i].anteprima);
      this.foto.splice(i, 1);
      this.ricalcola();
    },
    statoFoto(f) {
      return { attesa: this.t.fotoAttesa, lettura: this.t.fotoLettura, ok: this.t.fotoLetta, vuoto: this.t.fotoVuota, errore: this.t.errore }[f.stato] || "";
    },
    // ---------------- CAMPI ----------------
    opzioniPiene(opzioni) {
      return (opzioni || []).filter((o) => o.key);
    },
    italiano(nazione) {
      return !nazione || String(nazione) === ITALIA;
    },
    segna(campo) {
      this.$set(this.modificati, campo, true);
    },
    /** verificato (o coerente con il codice fiscale) / da controllare; nulla se corretto a mano o vuoto. */
    badge(campo) {
      if (this.modificati[campo] || !this.dati || !this.dati[campo]) {
        return "";
      }
      const a = this.affidabilita[campo];
      return a === "verificato" || a === "coerente" ? "verificato" : "letto";
    },
    testoBadge(campo) {
      return this.badge(campo) === "verificato" ? this.t.verificato : this.t.daControllare;
    },
    cambiaProvincia() {
      this.segna("prov_nascita");
      this.dati.comune_nascita = "";
      this.caricaComuni(this.dati.prov_nascita);
    },
    caricaComuni(provincia) {
      this.comuniNascita = [];
      if (!provincia) {
        return;
      }
      apiService.get("BE_riepilogo/comuni/" + provincia).then((resp) => {
        const opzioni = (resp && resp.opzioni) || [];
        const letto = this.dati && this.dati.comune_nascita;
        if (letto && this.nomeComuneNascita && !opzioni.some((o) => String(o.key) === String(letto))) {
          opzioni.unshift({ key: letto, label: this.nomeComuneNascita });
        }
        this.comuniNascita = opzioni;
      });
    },
    // ---------------- FOTOCAMERA ----------------
    /**
     * Fotocamera dentro la pagina (getUserMedia): lo scatto non finisce nella
     * galleria del telefono, resta in memoria e si scarta alla chiusura.
     */
    async apriFotocamera() {
      this.errore = "";
      // App Fotocamera del telefono: qualita' piena, ma su alcuni Android la
      // foto resta anche in galleria (lo dice il testo della privacy).
      if (this.usaAppFotocamera && this.$refs.scattoTelefono) {
        this.$refs.scattoTelefono.click();
        return;
      }
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.errore = this.t.noFotocamera;
        return;
      }
      try {
        this.flusso = await apriFlusso();
        this.fotocamera.pronta = false;
        this.fotocamera.attiva = true;
        await this.$nextTick();
        const video = this.$refs.video;
        video.onloadedmetadata = () => {
          this.fotocamera.pronta = true;
        };
        video.srcObject = this.flusso;
      } catch (e) {
        this.chiudiFotocamera();
        this.errore = e && e.name === "NotAllowedError" ? this.t.fotocameraNegata : this.t.noFotocamera;
      }
    },
    chiudiFotocamera() {
      if (this.flusso) {
        this.flusso.getTracks().forEach((t) => t.stop());
        this.flusso = null;
      }
      this.fotocamera.attiva = false;
      this.fotocamera.pronta = false;
      this.fotocamera.scatto = false;
    },
    /**
     * Scatta: vera foto dove il browser la permette, altrimenti il fotogramma
     * piu' nitido del video (services/docscan/fotocamera). Poi la fotocamera
     * si chiude e la foto, rimasta in memoria, si legge come le altre.
     */
    async scatta() {
      const video = this.$refs.video;
      if (!video || !video.videoWidth || this.fotocamera.scatto) {
        return;
      }
      this.fotocamera.scatto = true;
      let blob = null;
      try {
        blob = await scattaFoto(this.flusso, video, this.$refs.cornice);
      } finally {
        this.chiudiFotocamera();
      }
      if (blob) {
        this.leggiFile([blob]);
      }
    },
    aggiungi(evt) {
      const file = Array.from(evt.target.files || []);
      evt.target.value = "";
      this.leggiFile(file);
    },
    rilascia(evt) {
      const file = Array.from((evt.dataTransfer && evt.dataTransfer.files) || []).filter((f) => f.type.startsWith("image/"));
      if (file.length) {
        this.leggiFile(file);
      }
    },
    // ---------------- LETTURA ----------------
    leggiFile(file) {
      this.errore = "";
      for (const f of file) {
        this.foto.push({ id: ++progressivo, anteprima: URL.createObjectURL(f), file: f, stato: "attesa", letto: null, da: 0, a: 0, sfocata: false });
      }
      this.elabora();
    },
    /** Legge le foto in coda una alla volta (il lettore ne fa una per volta). */
    async elabora() {
      if (this.elaborazione) {
        return;
      }
      this.elaborazione = true;
      try {
        let voce;
        while ((voce = this.foto.find((f) => f.stato === "attesa"))) {
          voce.stato = "lettura";
          try {
            voce.letto = await docscan.leggi(
              voce.file,
              (m, da, a) => {
                voce.da = da || 0;
                voce.a = a || 0;
              },
              // Detto subito: si puo' rifare la foto senza aspettare la lettura.
              () => {
                voce.sfocata = true;
              }
            );
            const l = voce.letto;
            voce.stato = l.mrz || l.codiceFiscale || l.patenteUsa || l.patenteUe || (l.viz && (l.viz.comuneRilascio || l.viz.luoghi.length || l.viz.fronte)) ? "ok" : "vuoto";
          } catch (e) {
            voce.stato = "errore";
          }
          voce.file = null;
          this.ricalcola();
        }
      } finally {
        this.elaborazione = false;
      }
    },
    /** Unisce le letture di tutte le foto e chiede al server i codici delle tabelle. */
    ricalcola() {
      const letti = this.foto.filter((f) => f.letto).map((f) => f.letto);
      const punti = (m) => (m ? Object.values(m.controlli).filter(Boolean).length : -1);
      const mrz = letti.map((l) => l.mrz).reduce((m, x) => (punti(x) > punti(m) ? x : m), null);
      const campiPatente = (p) => (p ? p.campiLetti : -1);
      const codiceFiscale = letti.map((l) => l.codiceFiscale).find(Boolean) || null;
      const patenteUsa = letti.map((l) => l.patenteUsa).find(Boolean) || null;
      const patenteUe = letti.map((l) => l.patenteUe).reduce((p, x) => (campiPatente(x) > campiPatente(p) ? x : p), null);
      const viz = unisciViz(letti.map((l) => l.viz));
      if (!mrz && !codiceFiscale && !patenteUsa && !patenteUe && !viz) {
        return;
      }
      const cf = codiceFiscale ? { ...codiceFiscale } : null;
      const documento = mrz || patenteUsa || patenteUe;
      const origine = mrz ? "mrz" : patenteUsa ? "aamva" : patenteUe ? "patente" : "";
      if (cf && documento && documento.cognome) {
        cf.nomeNonCorrisponde = !corrispondeA(cf.codice, documento.cognome, documento.nome);
      }
      this.richieste++;
      apiService
        .post("BE_prenotazione/docscan/" + this.token, { origine, documento, codiceFiscale: cf, viz })
        .then((resp) => this.applicaRisposta(resp))
        .catch(() => {
          this.errore = this.t.errore;
        })
        .finally(() => {
          this.richieste--;
        });
    },
    /** Valori della decodifica nei campi del web check-in; le correzioni dell'ospite restano. */
    applicaRisposta(resp) {
      const v = resp.valori || {};
      const letti = {
        cognome: v.cognome || "",
        nome: v.nome || "",
        sesso: v.sesso || "",
        data_nascita: v.datanascita || "",
        cittadinanza: codice(v.nazionalita),
        nazione_nascita: codice(v.nazione_na),
        prov_nascita: codice(v.provincia_na),
        comune_nascita: codice(v.citta_na),
        nazione_residenza: codice(v.nazione),
        tipodoc: v.tipodoc1 || "",
        nrodoc: v.numdoc || "",
        nazione_rilascio: codice(v.stato),
        comune_rilascio: codice(v.comune)
      };
      const prima = this.dati || {};
      const dati = {};
      const affidabilita = {};
      Object.keys(letti).forEach((c) => {
        dati[c] = this.modificati[c] ? prima[c] : letti[c];
        affidabilita[c] = (resp.affidabilita || {})[FONTE[c]] || "letto";
      });
      if (!this.modificati.comune_nascita) {
        this.nomeComuneNascita = v.citta_na && v.citta_na.label ? v.citta_na.label : "";
      }
      const provinciaCambiata = dati.prov_nascita !== prima.prov_nascita;
      this.dati = dati;
      this.affidabilita = affidabilita;
      if (provinciaCambiata) {
        this.caricaComuni(dati.prov_nascita);
      }
    }
  }
};
</script>

<style lang="scss">
// Sopra tutta la pagina del riepilogo; sul telefono a schermo intero.
.scan-velo {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.47);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2a364d;

  // Tutto dentro .scan-velo: la pagina ha ".home button" che azzera gli
  // stili dei bottoni e vincerebbe sulle classi semplici.
  .scan-finestra {
    width: 980px;
    max-width: 95vw;
    height: 88vh;
    background: #f4f5f8;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  }
  .scan-testata {
    padding: 12px 12px 12px 18px;
    display: flex;
    align-items: center;
    gap: 10px;
    text-shadow: rgb(0 0 0 / 20%) 0 2px 4px;
    .scan-testata-titolo {
      flex: 1;
      font-size: 1.15em;
      font-weight: bold;
      text-transform: uppercase;
    }
    .scan-x {
      border: 0;
      background: transparent;
      font-size: 1.3em;
      padding: 0 8px;
      cursor: pointer;
    }
  }
  .scan-corpo {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
  }
  .scan-avviso {
    padding: 10px 12px;
    background: #fff4e0;
    border: 1px solid #e8b04a;
    font-size: 0.9em;
    line-height: 1.45;
    margin: 10px 0;
  }
  .scan-nota {
    font-size: 0.9em;
    color: #585858;
    margin-bottom: 10px;
  }

  // ---------------- INIZIO ----------------
  .scan-inizio {
    max-width: 520px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .scan-grande {
    border: 0;
    padding: 28px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    text-shadow: rgb(0 0 0 / 20%) 0 2px 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    .scan-grande-icona {
      width: 78px;
      height: 78px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.18);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 36px;
    }
    .scan-grande-titolo {
      font-size: 1.35em;
      font-weight: bold;
    }
    .scan-grande-sotto {
      font-size: 0.85em;
      opacity: 0.9;
      text-align: center;
    }
  }
  .scan-carica {
    min-height: 50px;
    border: 1px solid;
    background: #fff;
    font-weight: bold;
    cursor: pointer;
  }
  .scan-avvicinati {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #e2e6ec;
    color: #2a364d;
    font-weight: bold;
  }
  .scan-lati {
    background: #fff;
    padding: 12px 14px;
    font-size: 0.9em;
    line-height: 1.6;
    color: #585858;
    b {
      color: #2a364d;
    }
  }
  .scan-privacy {
    display: flex;
    gap: 8px;
    font-size: 0.8em;
    line-height: 1.5;
    color: #585858;
  }

  .scan-crediti {
    margin-top: 12px;
    font-size: 0.75em;
    color: #8a8a8a;
    a {
      color: inherit;
      text-decoration: underline;
    }
  }

  // ---------------- FOTO E DATI ----------------
  .scan-foto-griglia {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
  .scan-foto {
    position: relative;
    height: 120px;
    overflow: hidden;
    background: #e3e6ec;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .scan-foto-stato {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 4px 8px;
      font-size: 0.8em;
      background: rgba(255, 255, 255, 0.92);
      &.stato-vuoto,
      &.stato-errore {
        color: #b3261e;
      }
    }
    .scan-foto-sfocata {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      padding: 4px 36px 4px 8px;
      font-size: 0.8em;
      color: #fff;
      background: rgba(179, 38, 30, 0.9);
    }
    .scan-foto-togli {
      position: absolute;
      top: 5px;
      right: 5px;
      width: 26px;
      height: 26px;
      border: 0;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      cursor: pointer;
    }
  }
  .scan-foto-aggiungi {
    height: 120px;
    border: 2px dashed #8796a8;
    background: transparent;
    font-weight: bold;
    font-size: 0.9em;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    cursor: pointer;
    .scan-foto-aggiungi-icona {
      font-size: 24px;
    }
    small {
      font-weight: normal;
      color: #585858;
    }
  }
  .scan-link {
    border: 0;
    background: transparent;
    padding: 8px 0;
    font-size: 0.9em;
    font-weight: bold;
    cursor: pointer;
  }
  .scan-dati {
    margin-top: 10px;
    scroll-margin-top: 8px;
  }
  // Campi come nel web check-in: stessi riquadri, etichetta piccola sopra.
  .scan-sezione {
    background: #fff;
    padding: 10px 14px 14px;
    margin-bottom: 12px;
    .persona_label {
      border-bottom: 1px solid #00000088;
      opacity: 0.5;
      font-size: 0.8em;
      font-weight: lighter;
      padding-bottom: 5px;
      margin-bottom: 4px;
      text-transform: uppercase;
    }
    .cyb-input {
      border: 1px solid #585858;
      input,
      select {
        font-size: 16px; // sotto i 16px iOS ingrandisce la pagina
      }
    }
  }
  .scan-campo {
    margin-top: 6px;
  }
  .scan-etichetta {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 8px;
    font-size: 0.8em;
    color: #585858;
    min-height: 18px;
  }
  .scan-sesso {
    margin-top: 20px !important;
    input {
      margin-right: 4px;
    }
    span {
      margin-right: 14px;
    }
  }
  .scan-badge {
    font-size: 0.85em;
    padding: 0 6px;
    white-space: nowrap;
    &.badge-verificato {
      background: #e3f1e7;
      color: #1b6b35;
    }
    &.badge-letto {
      background: #fff4e0;
      color: #8a4f00;
    }
  }

  // ---------------- BARRA ----------------
  .scan-barra {
    flex: none;
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.08);
    padding: 10px 14px calc(12px + env(safe-area-inset-bottom));
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    .scan-barra-annulla {
      min-height: 46px;
      padding: 0 18px;
      border: 1px solid #585858;
      background: #fff;
      color: #2a364d;
      cursor: pointer;
    }
    .scan-barra-usa {
      min-height: 46px;
      min-width: 240px;
      border: 0;
      font-weight: bold;
      font-size: 1.05em;
      &:disabled {
        opacity: 0.45;
        cursor: default;
      }
    }
  }

  // ---------------- ATTESA ----------------
  .scan-attesa {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2002;
    background: rgba(255, 255, 255, 0.93);
    cursor: wait;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    text-align: center;
    padding: 20px;
    color: #2a364d;
    .scan-attesa-percentuale {
      font-size: 2.6em;
      font-weight: bold;
      line-height: 1;
    }
    .scan-attesa-barra {
      width: min(320px, 80vw);
      height: 8px;
      background: #e3e6ec;
      overflow: hidden;
      div {
        height: 100%;
        transition: width 0.25s linear;
      }
    }
    .scan-attesa-titolo {
      font-size: 1.25em;
      font-weight: bold;
    }
    .scan-attesa-nota {
      font-size: 0.9em;
      color: #585858;
    }
    .scan-attesa-passi {
      font-size: 0.9em;
      text-align: left;
      .passo-attesa {
        color: #9aa3ae;
      }
      .passo-lettura {
        font-weight: bold;
      }
      .passo-vuoto,
      .passo-errore {
        color: #b3261e;
      }
    }
  }

  // ---------------- FOTOCAMERA ----------------
  .scan-fotocamera {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2001;
    background: #000;
    overflow: hidden;
    video {
      position: absolute;
      top: 0;
    right: 0;
    bottom: 0;
    left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    // cornice con le proporzioni di una carta d'identita' (85,6 x 54 mm)
    .scan-cornice {
      position: absolute;
      left: 50%;
      top: 47%;
      width: min(88vw, 720px);
      max-height: 60vh;
      aspect-ratio: 85.6 / 54;
      transform: translate(-50%, -50%);
      border: 3px solid rgba(255, 255, 255, 0.95);
      border-radius: 14px;
      box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.45);
      pointer-events: none;
    }
    .scan-fotocamera-testo {
      position: absolute;
      top: calc(16px + env(safe-area-inset-top));
      left: 16px;
      right: 16px;
      color: #fff;
      text-align: center;
      font-size: 15px;
      line-height: 1.45;
      text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
    }
    .scan-fotocamera-sotto {
      font-size: 13px;
      opacity: 0.85;
      margin-top: 4px;
    }
    .scan-fotocamera-comandi {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 18px 20px calc(24px + env(safe-area-inset-bottom));
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: rgba(0, 0, 0, 0.5);
    }
    .scan-fotocamera-chiudi {
      width: 110px;
      border: 0;
      background: transparent;
      color: #fff;
      text-align: left;
      cursor: pointer;
    }
    .scan-fotocamera-lato {
      width: 110px;
    }
    .scan-scatta {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      border: 5px solid #fff;
      background: transparent;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      span {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background: #fff;
      }
      &:disabled {
        opacity: 0.4;
      }
    }
  }

  // Telefono: finestra a tutto schermo, bottone principale largo.
  @media (max-width: 576px) {
    .scan-finestra {
      width: 100%;
      max-width: 100%;
      height: 100%;
    }
    .scan-barra .scan-barra-usa {
      flex: 1;
      min-width: 0;
    }
  }
}
</style>
